// extracted by mini-css-extract-plugin
export default {"container":"CompareButton_container__DXQlN","button":"CompareButton_button__Qso6C"};